import { createRouter, createWebHistory } from 'vue-router'
import { initAuthorized, isAuthorized } from '@/utils/auth'

const routes = [
    {
        path: '/WeChatAuth',
        component: () => import('@/views/WeChatAuth.vue'),
        meta: { auth: false, title: '授权' }
    },
    {
        path: '/',
        component: () => import('@/views/login/index.vue'),
        meta: { auth: false, title: '登录' }
    },
    {
        path: '/wxMpAuth',
        component: () => import('@/views/login/wxMpAuth.vue'),
        meta: { auth: false, title: '公众号授权' }
    },
    {
        path: '/binding',
        component: () => import('@/views/binding/index.vue'),
        meta: { auth: false, title: '咨询师绑定' }
    },
    {
        path: '/home',
        component: () => import('@/views/home/index.vue'),
        meta: { auth: true, title: '首页' },
        children: [
            {
                path: '',
                redirect: '/home/order'
            },
            {
                path: 'order',
                component: () => import('@/views/order/order.vue'),
                meta: { auth: true, title: '订单信息' }
            },
            {
                path: 'room',
                component: () => import('@/views/room/index.vue'),
                meta: { auth: true, title: '会议室预约' }
            },
            {
                path: 'scheduling/doctor',
                component: () => import('@/views/scheduling/doctor/index.vue'),
                meta: { auth: true, title: '我的排班' }
            },
            {
                path: 'scheduling',
                component: () => import('@/views/scheduling/index/index.vue'),
                meta: { auth: true, title: '我的排班' }
            }
        ]
    },
    {
        path: '/guide',
        component: () => import('@/views/guide/index.vue'),
        meta: { auth: false, title: '订单引导' }
    },

]

const router = createRouter({
    history: createWebHistory(),
    routes
})

// 初始化授权状态
// initAuthorized();

router.beforeEach((to, from, next) => {
    console.log('路由守卫检查授权状态')
    document.title = to.meta.title || '默认标题'
    if (to.meta.auth && !isAuthorized()) {
        console.log('未授权，重定向到授权页面')
        next({ path: '/' })
    }else {
        console.log('已授权，允许访问')
        next()
    }
})

// 授权后，重定向到目标页面
router.afterEach((to) => {
    console.log(to.query.redirect)
    if (to.path === '/' && isAuthorized()) {
        console.log('已授权，重定向到目标页面')
        const redirectPath = to.query.redirect || '/home'
        console.log(redirectPath)
        router.replace(redirectPath)
    }
})

export default router
